module.exports = __webpack_public_path__ + "static/media/3XL.552c4d30.jpg";